var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "reset-password" } }, [
    _c("h2", [_vm._v("Reset Password")]),
    _vm._v(" "),
    _vm.resetPasswordStatus == "success"
      ? _c(
          "div",
          [
            _c("el-alert", {
              attrs: {
                type: "success",
                title:
                  "An email has been sent to you with a link to confirm your new password"
              }
            })
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.resetPasswordStatus != "success"
      ? _c(
          "div",
          [
            _c("p", [
              _vm._v(
                "Please choose a new password and we'll send you an email with a link to activate it"
              )
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.resetPasswordStatus == "pending",
                    expression: "resetPasswordStatus == 'pending'"
                  }
                ],
                attrs: {
                  novalidate: "true",
                  "label-width": "10em",
                  "label-position": _vm.formLabelPosition,
                  size: _vm.formSize
                }
              },
              [
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "Email address", error: _vm.errors.email }
                  },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "Enter your email" },
                      model: {
                        value: _vm.email,
                        callback: function($$v) {
                          _vm.email = $$v
                        },
                        expression: "email"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: { label: "New Password", error: _vm.errors.password }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "Enter as new password",
                        "show-password": ""
                      },
                      model: {
                        value: _vm.password,
                        callback: function($$v) {
                          _vm.password = $$v
                        },
                        expression: "password"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  {
                    attrs: {
                      label: "Confirm Password",
                      error: _vm.errors.password_confirmation
                    }
                  },
                  [
                    _c("el-input", {
                      attrs: {
                        placeholder: "Confirm your new password",
                        "show-password": ""
                      },
                      model: {
                        value: _vm.password_confirmation,
                        callback: function($$v) {
                          _vm.password_confirmation = $$v
                        },
                        expression: "password_confirmation"
                      }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.requestResetPassword }
                      },
                      [_vm._v("Submit")]
                    )
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }